export const core = {
  title: 'RECLAMA TU PREMIO',
  subtitleCasino: '100 GIROS GRATIS',
  subtitleSport: '100 LEMPIRAS',

  // FORM
  labelEmail: 'Correo electrónico',
  labelPassword: 'Contraseña',
  age: 'Confirmo que tengo 21 años y que he leído los Términos del Servicio',
  signUp: 'Regístrate',
  google: 'Google',
  phone: 'Teléfono',
  email: 'E-mail',
  code: '¿Tienes un código de afiliado?',
  codeInput: 'Código de afiliado',

  // FOOTER
  footer: 'Patrocinadores',
  copy: 'Copyright © 2025 interplay.tech - Todos los derechos reservados',
};
